import React from "react";
import {
  Box,
  Checkbox,
  IconButton,
  InboxIcon,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const ListItemIconCheckbox = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          List Item with checkbox and Icon
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          language="js"
          title={
            "A checkbox can either be a primary action or a secondary action."
          }
          background
          value={
            "" +
            "                           <List>\n" +
            "                            {[0, 1, 2, 3].map((value) => {\n" +
            "                                return (\n" +
            "                                    <ListItem\n" +
            "                                        key={value}\n" +
            "                                        secondaryAction={\n" +
            '                                            <IconButton edge="end" aria-label="comments">\n' +
            '                                                <InboxIcon fontSize={"small"} />\n' +
            "                                            </IconButton>\n" +
            "                                        }\n" +
            "                                        disablePadding\n" +
            "                                    >\n" +
            "                                        <ListItemButton role={undefined} dense>\n" +
            "                                            <ListItemIcon sx={{mr:0}}>\n" +
            "                                                <Checkbox\n" +
            '                                                    size={"small"}\n' +
            '                                                    edge="start"\n' +
            "                                                    tabIndex={-1}\n" +
            "                                                    disableRipple\n" +
            "                                                />\n" +
            "                                            </ListItemIcon>\n" +
            "                                            <ListItemText primary={`Line item ${value + 1}`} />\n" +
            "                                        </ListItemButton>\n" +
            "                                    </ListItem>\n" +
            "                                );\n" +
            "                            })}\n" +
            "                        </List>"
          }
        >
          <Paper p={3} elevation={0} sx={{ width: 250 }}>
            <List>
              {[0, 1, 2, 3].map((value) => {
                return (
                  <ListItem
                    key={value}
                    secondaryAction={
                      <IconButton edge="end" aria-label="comments">
                        <InboxIcon fontSize={"small"} />
                      </IconButton>
                    }
                    disablePadding
                  >
                    <ListItemButton role={undefined} dense>
                      <ListItemIcon sx={{ mr: 0 }}>
                        <Checkbox
                          size={"small"}
                          edge="start"
                          tabIndex={-1}
                          disableRipple
                        />
                      </ListItemIcon>
                      <ListItemText primary={`Line item ${value + 1}`} />
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          </Paper>
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default ListItemIconCheckbox;
